import { format, parseISO } from 'date-fns'
import { es } from 'date-fns/locale'

/**
 * Fechas HUMANAS para superficies admin (convención del checklist): las fechas
 * visibles en tablas/paneles se leen como texto — "14 de febrero, 2026" y
 * "14 de febrero, 2026 a las 12:16" — nunca dd/MM/yyyy. Los documentos
 * impresos (FEIC/promesa/estado patrimonial) mantienen dd/MM/yyyy: formato legal.
 */

/**
 * Parseo tolerante: lo canónico es ISO 8601 (`parseISO`), pero hay datos legacy
 * guardados con `Date.prototype.toString()` — p.ej. el historial de estados de
 * negociaciones, cuyo schema tipaba `startDate`/`endDate` como `string` y Mongoose
 * casteaba el `Date` a texto ("Tue Apr 08 2025 22:44:37 GMT+0000 (...)").
 * `parseISO` rechaza ese formato, así que caemos al constructor nativo.
 * Cuando la migración a `Date` termine, este fallback se puede borrar.
 */
function toDate(value: string | Date): Date {
  if (typeof value !== 'string') return value
  const isoDate = parseISO(value)
  if (!Number.isNaN(isoDate.getTime())) return isoDate
  return new Date(value)
}

/** "14 de febrero, 2026" — para columnas y filas de detalle sin hora. */
export function formatHumanDate(value?: string | Date | null, fallback = '—'): string {
  if (!value) return fallback
  const date = toDate(value)
  if (Number.isNaN(date.getTime())) return fallback
  return format(date, "d 'de' MMMM, yyyy", { locale: es })
}

/** "14 de febrero, 2026 a las 12:16" — para autoría/actividad e historial. */
export function formatHumanDateTime(value?: string | Date | null, fallback = '—'): string {
  if (!value) return fallback
  const date = toDate(value)
  if (Number.isNaN(date.getTime())) return fallback
  return format(date, "d 'de' MMMM, yyyy 'a las' HH:mm", { locale: es })
}
